// src/components/LoadingScreen.jsx
import { motion } from 'framer-motion'
import { Loader2 } from 'lucide-react'

const LoadingScreen = () => {
    return (
        <div className="min-h-screen bg-gray-50 dark:bg-gray-900 flex items-center justify-center">
            <motion.div
                initial={{ opacity: 0, scale: 0.9 }}
                animate={{ opacity: 1, scale: 1 }}
                className="text-center"
            >
                <motion.div
                    animate={{ rotate: 360 }}
                    transition={{ duration: 1, repeat: Infinity, ease: "linear" }}
                    className="w-12 h-12 mx-auto mb-4"
                >
                    <Loader2 className="w-12 h-12 text-primary-600 dark:text-primary-400" />
                </motion.div>

                <motion.h2
                    initial={{ opacity: 0, y: 10 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ delay: 0.2 }}
                    className="text-xl font-semibold text-gray-900 dark:text-white mb-2"
                >
                    BaraquBot
                </motion.h2>

                <motion.p
                    initial={{ opacity: 0, y: 10 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ delay: 0.3 }}
                    className="text-gray-600 dark:text-gray-300"
                >
                    Loading your smart home...
                </motion.p>
            </motion.div>
        </div>
    )
}

export default LoadingScreen